import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const PoweredBy = styled.div`
    ${p => p.theme.utils.flex({ jc: 'flex-start' })};
    p {
        margin-right: 7px;
        text-decoration: none !important;
        font-size: 16px;
        color: ${p => p.theme.headerTextColor};
        opacity: 0.6;

        ${cssMediaQueryBreakpoints.medium} {
            display: none;
        }
    }
`
